const BidStatus = ({product}) => {

    const endBidTime = new Date(product?.end_bid_date).getTime();
    const currentTime = new Date().getTime();

    return (
        <>
            {(endBidTime - currentTime) > 0 ? (
                <div style={{fontSize:16,fontWeight:600,color:'green',textAlign:'center'}}>Live</div>
            ):(
                <div style={{fontWeight:600,textAlign:'center'}}>Bid Ended</div>
            )}
        </>
    );
}

export default BidStatus;